import React, { useState } from 'react';

export default function WhatsAppButton({ phoneNumber = "917499556654" }) {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    city: '',
    size: 'Select',
    shoppingFor: 'Select',
    style: 'Select',
    preference: 'Select'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContinue = (e) => {
    e.preventDefault();
    
    // Construct the message
    const msgLines = [
      `Hi Bamboosa Team, I am interested in purchasing a bamboo T-shirt.`,
      `Name: ${formData.name}`,
      `City: ${formData.city}`,
      `Shopping for: ${formData.shoppingFor === 'Select' ? '-' : formData.shoppingFor}`,
      `Style: ${formData.style === 'Select' ? '-' : formData.style}`,
      `Size: ${formData.size === 'Select' ? '-' : formData.size}`,
      `Preference: ${formData.preference === 'Select' ? '-' : formData.preference}`,
      `Please share suitable product photos, available colours, price and purchase link.`
    ];
    
    const finalMessage = msgLines.join('\n');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(finalMessage)}`;
    
    window.open(whatsappUrl, '_blank');
    setShowModal(false);
  };

  return (
    <>
      <div 
        className="whatsapp-floating-btn"
        title="Chat with us on WhatsApp"
        onClick={() => setShowModal(true)}
        style={{ cursor: 'pointer' }}
      >
        <i className="fa fa-whatsapp"></i>
      </div>

      {showModal && (
        <div className="wa-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="wa-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="wa-modal-close" onClick={() => setShowModal(false)}>
              &times;
            </button>

            <p className="wa-modal-subtitle">BAMBOOSA STYLE ADVISOR</p>
            <h2 className="wa-modal-title">Let us help you choose</h2>
            <p className="wa-modal-desc">
              Share your requirements. WhatsApp will open with a pre-filled message.
            </p>

            <form onSubmit={handleContinue} className="wa-modal-form">
              <div className="wa-form-row">
                <div className="wa-form-group">
                  <label>Name</label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formData.name} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>
              </div>

              <div className="wa-form-row">
                <div className="wa-form-group wa-col">
                  <label>City</label>
                  <input 
                    type="text" 
                    name="city" 
                    value={formData.city} 
                    onChange={handleInputChange} 
                    required 
                  />
                </div>
                <div className="wa-form-group wa-col">
                  <label>Size</label>
                  <select name="size" value={formData.size} onChange={handleInputChange}>
                    <option value="Select">Select</option>
                    <option value="S">S</option>
                    <option value="M">M</option>
                    <option value="L">L</option>
                    <option value="XL">XL</option>
                  </select>
                </div>
              </div>

              <div className="wa-form-row">
                <div className="wa-form-group wa-col">
                  <label>Shopping for</label>
                  <select name="shoppingFor" value={formData.shoppingFor} onChange={(e) => {
                    handleInputChange(e);
                    // Reset style and preference when shoppingFor changes
                    setFormData(prev => ({ ...prev, style: 'Select', preference: 'Select' }));
                  }}>
                    <option value="Select">Select</option>
                    <option value="Men">Men</option>
                    <option value="Women">Women</option>
                  </select>
                </div>
                <div className="wa-form-group wa-col">
                  <label>Style</label>
                  <select name="style" value={formData.style} onChange={(e) => {
                    handleInputChange(e);
                    // Reset preference when style changes
                    setFormData(prev => ({ ...prev, preference: 'Select' }));
                  }}>
                    <option value="Select">Select</option>
                    {formData.shoppingFor === 'Men' && (
                      <>
                        <option value="Polo Neck Men">Polo Neck Men</option>
                        <option value="Round Neck Men">Round Neck Men</option>
                      </>
                    )}
                    {formData.shoppingFor === 'Women' && (
                      <>
                        <option value="Polo Neck Women">Polo Neck Women</option>
                        <option value="Round Neck Women">Round Neck Women</option>
                      </>
                    )}
                    {formData.shoppingFor === 'Select' && (
                      <>
                        <option value="Polo Neck Men">Polo Neck Men</option>
                        <option value="Polo Neck Women">Polo Neck Women</option>
                        <option value="Round Neck Men">Round Neck Men</option>
                        <option value="Round Neck Women">Round Neck Women</option>
                      </>
                    )}
                  </select>
                </div>
              </div>

              <div className="wa-form-row">
                <div className="wa-form-group">
                  <label>Preferred product or colour</label>
                  <select name="preference" value={formData.preference} onChange={handleInputChange}>
                    <option value="Select">Select</option>
                    {formData.style === 'Polo Neck Women' && (
                      <>
                        <option value="Black">Black</option>
                        <option value="Maroon">Maroon</option>
                        <option value="Blue">Blue</option>
                        <option value="Khaki/Mustard">Khaki/Mustard</option>
                        <option value="Green">Green</option>
                      </>
                    )}
                    {formData.style === 'Round Neck Women' && (
                      <>
                        <option value="Black">Black</option>
                        <option value="Windsor Wine">Windsor Wine</option>
                        <option value="Sepia Rose">Sepia Rose</option>
                        <option value="Blue">Blue</option>
                        <option value="Satellite">Satellite</option>
                      </>
                    )}
                    {formData.style === 'Polo Neck Men' && (
                      <>
                        <option value="Black">Black</option>
                        <option value="Blue">Blue</option>
                        <option value="Green">Green</option>
                        <option value="Khaki/Mustard">Khaki/Mustard</option>
                        <option value="Maroon">Maroon</option>
                      </>
                    )}
                    {formData.style === 'Round Neck Men' && (
                      <>
                        <option value="Black">Black</option>
                        <option value="Windsor Wine">Windsor Wine</option>
                        <option value="Blue">Blue</option>
                        <option value="Sepia Rose">Sepia Rose</option>
                        <option value="Satellite">Satellite</option>
                      </>
                    )}
                    {formData.style === 'Select' && (
                      <>
                        <option value="Black">Black</option>
                        <option value="Maroon">Maroon</option>
                        <option value="Blue">Blue</option>
                        <option value="Khaki/Mustard">Khaki/Mustard</option>
                        <option value="Green">Green</option>
                        <option value="Windsor Wine">Windsor Wine</option>
                        <option value="Sepia Rose">Sepia Rose</option>
                        <option value="Satellite">Satellite</option>
                      </>
                    )}
                  </select>
                </div>
              </div>

              <button type="submit" className="wa-submit-btn">
                Continue on WhatsApp
              </button>
            </form>
          </div>

          <style>
            {`
              .wa-modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background: rgba(0,0,0,0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 999999;
                padding: 15px;
              }
              .wa-modal-content {
                background: #fff;
                width: 100%;
                max-width: 500px;
                border-radius: 12px;
                padding: 30px;
                position: relative;
                box-shadow: 0 10px 25px rgba(0,0,0,0.1);
              }
              .wa-modal-close {
                position: absolute;
                top: 15px;
                right: 20px;
                background: none;
                border: none;
                font-size: 24px;
                cursor: pointer;
                color: #333;
                font-weight: bold;
              }
              .wa-modal-subtitle {
                font-size: 12px;
                font-weight: 700;
                color: #2b5d4c;
                margin-bottom: 5px;
                letter-spacing: 1px;
                text-transform: uppercase;
              }
              .wa-modal-title {
                font-size: 32px;
                color: #1a3b34;
                margin-bottom: 10px;
                font-weight: 600;
                font-family: serif;
              }
              .wa-modal-desc {
                font-size: 14px;
                color: #555;
                margin-bottom: 25px;
                line-height: 1.5;
              }
              .wa-modal-form {
                display: flex;
                flex-direction: column;
                gap: 15px;
              }
              .wa-form-row {
                display: flex;
                gap: 15px;
                width: 100%;
              }
              .wa-form-group {
                display: flex;
                flex-direction: column;
                flex: 1;
              }
              .wa-form-group label {
                font-size: 13px;
                font-weight: 700;
                color: #000;
                margin-bottom: 6px;
              }
              .wa-form-group input,
              .wa-form-group select {
                padding: 10px 12px;
                border: 1px solid #ddd;
                border-radius: 6px;
                font-size: 14px;
                outline: none;
                transition: border-color 0.2s;
                background-color: #fff;
                width: 100%;
                box-shadow: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
              }
              .wa-form-group select {
                background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23333333%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
                background-repeat: no-repeat;
                background-position: right 12px center;
                background-size: 10px auto;
                padding-right: 30px;
                cursor: pointer;
              }
              .wa-form-group input:focus,
              .wa-form-group select:focus {
                border-color: #2b5d4c;
              }
              .wa-submit-btn {
                background: #1a3b34;
                color: #fff;
                border: none;
                border-radius: 6px;
                padding: 14px;
                font-size: 16px;
                font-weight: 600;
                cursor: pointer;
                margin-top: 10px;
                transition: background 0.2s;
              }
              .wa-submit-btn:hover {
                background: white;
                color: #1a3b34;
                box-shadow: inset 0 0 0 1px #1a3b34;
              }
              
              @media (max-width: 500px) {
                .wa-form-row {
                  flex-direction: column;
                  gap: 15px;
                }
                .wa-modal-content {
                  padding: 20px;
                }
                .wa-modal-title {
                  font-size: 26px;
                }
              }
            `}
          </style>
        </div>
      )}
    </>
  );
}
